import { useEffect, useState } from "react";
import { useSessionStore } from "Common/Stores";
import { getAllPermisionsByUsers, OptionsMenuService } from "services";
import {
  MenuItem,
  PermissionsResponse,
  PermissionsResponseMenu,

  // PermissionsResponses,
} from "interfaces";
import {
  MonitorDot,
  ShieldCheck,
  ShieldEllipsis,
  PackageSearchIcon,
  ShoppingBag,
  List,
  ScrollText,
} from "lucide-react";
import { layoutStore } from "./VerticalLayout/store/layoutMenu.store";
import { transformToMenu } from "./allowedPages";
import { useStore } from "zustand";



export const useMenuData = () => {
  const [menuData, setMenuData] = useState<MenuItem[]>([]);
  const [permissionsResponse, setpermissionsResponse] = useState<
    PermissionsResponseMenu[]
  >([]);
  const {
    getMenuCache,
    setMenuCache,
    shouldRefreshMenu,
    resetRefreshFlag,
  } = useStore(layoutStore);

  const session = useSessionStore((state) => state.session);

  useEffect(() => {
    if (!session?.user?.id) {
      console.warn("La sesión aún no está disponible.");
      return;
    }

    const fetchMenuData = async () => {
      try {
        const user_id = Number(session.user.id);

        const cachedPermissions = getMenuCache(user_id);

      
          if ( !shouldRefreshMenu && cachedPermissions && cachedPermissions.length > 0) {
        
            const transformed = transformToMenu(cachedPermissions); 
            setMenuData(transformed);
            return; 
          }

        const menuResponse = await OptionsMenuService();
        if (!menuResponse?.data || menuResponse.data.length === 0) {
          return;
        }

        const baseMenu = menuResponse.data;

        const apiPermissionsResponse = await getAllPermisionsByUsers(user_id);
        setpermissionsResponse(apiPermissionsResponse.data);


        const allowedUrls = apiPermissionsResponse.data
          .map((item) => item.option?.url)
          .filter((url): url is string => !!url)
          .map((url) => url.toLowerCase());

        const allowedPages = apiPermissionsResponse.data.filter((permiso) => {
          const permisoUrl = permiso.option?.url?.toLowerCase().trim();
          const permisoDesc = permiso.option?.description?.toLowerCase().trim();

          return baseMenu.some((menuItem) => {
            const menuUrl = menuItem.url?.toLowerCase().trim();
            const menuDesc = menuItem.description?.toLowerCase().trim();

            return permisoUrl === menuUrl && permisoDesc === menuDesc;
          });
        });


        const menuMap: Record<string, MenuItem> = {};

        if (allowedPages.length === 0) {
          console.warn("\n\n No hay permisos válidos. \n\n");
          return;
        }
  
        const transformed = transformToMenu(allowedPages); 
        setMenuCache(user_id, allowedPages); 
        setMenuData(transformed); 
        resetRefreshFlag();

      } catch (error) {
        console.error("Error obteniendo datos del menú:", error);
      }
    };

    fetchMenuData();
  }, [session, shouldRefreshMenu]);

  useEffect(() => {
  }, [menuData]);

  return menuData;
};
